export default __webpack_public_path__ + "88577e0cdac5232618b2913bdb8a0788.jpg";